module.exports = __webpack_public_path__ + "static/media/YF20_5.54ac6bc9.jpg";